/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreFlexCreateAliases {
  AUTOCOMPLETE_SCORE_FLEX = 'autocomplete-score-flex',
  FETCH_PROFESSIONAL = 'fetch-professional',
  FETCH_SCORE_FLEX = 'fetch-score-flex',
  FIELD_PROFESSIONAL = 'field-professional',
  FIELD_SCORE_FLEX = 'field-score-flex',
  FIELD_SETUP_DATE = 'field-setup-date',
  FORM_CONTEXTUAL_BAR = 'form-contextual-bar',
  FORM_SCORE_FLEX_ADD = 'form-score-flex-add',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_PROFESSIONAL = 'input-professional',
  INPUT_SETUP_DATE = 'input-setup-date',
  LOCATOR_FIELD_PROFESSIONAL = 'locator-field-professional',
  LOCATOR_PROFESSIONAL = 'locator-professional',
  MAPPER_SCORE_FLEX = 'mapper-score-flex',
  PANEL_0 = 'panel-0',
  PANEL_FORM = 'panel-form',
  PANEL_HEADER = 'panel-header',
  SCORE_FLEX_ADD_LAYOUT = 'score-flex-add-layout',
  TEXT_SCORE_FLEX = 'text-score-flex',
}
export { ScoreFlexCreateAliases };
